import { ProductType } from '@woolworthsnz/styleguide';
import { PageType } from '.';
import { CARTOLOGY_NEW_FAVOURITES, CARTOLOGY_NEW_PAST_ORDER } from '../constants/view-item-constants';

export function getItemVariant(pageSource: string | undefined, productType: ProductType | undefined): string {
	const pageSourceVariant = pageSource
		? {
				[PageType.pastOrders]: CARTOLOGY_NEW_PAST_ORDER,
				[PageType.favourites]: CARTOLOGY_NEW_FAVOURITES,
			}[pageSource]
		: '';

	return pageSourceVariant || productType || '';
}
